module.exports = __webpack_public_path__ + "static/img/popop.3c2ed13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popop.jpg
// module id = NG2N
// module chunks = 0